export class BotHelper {
	private crawlerUserAgents = [
		'googlebot',
		'Yahoo! Slurp',
		'bingbot',
		'yandex',
		'baiduspider',
		'facebookexternalhit',
		'twitterbot',
		'rogerbot',
		'linkedinbot',
		'embedly',
		'quora link preview',
		'showyoubot',
		'outbrain',
		'pinterest/0.',
		'developers.google.com/+/web/snippet',
		'slackbot',
		'vkShare',
		'W3C_Validator',
		'redditbot',
		'Applebot',
		'WhatsApp',
		'flipboard',
		'tumblr',
		'bitlybot',
		'SkypeUriPreview',
		'nuzzel',
		'Discordbot',
		'Google Page Speed',
		'Qwantify',
		'pinterestbot',
		'Bitrix link preview',
		'XING-contenttabreceiver',
		'Chrome-Lighthouse'
	];

	public isBot(): boolean {
		try {
			// eslint-disable-next-line @typescript-eslint/no-unused-expressions
			window === undefined || window.navigator === undefined;
		} catch {
			return false;
		}

		const userAgent = window.navigator.userAgent;
		return userAgent !== undefined
			&& (this.crawlerUserAgents
				.map(_ => userAgent.toLowerCase().includes(_.toLowerCase()))
				.reduce((previous, current) => previous || current)
			);
	}

	public isPrerender(): boolean {
		if (window === undefined || window.navigator === undefined) {
			return false;
		}

		const userAgent = window.navigator.userAgent;
		return userAgent !== undefined
			&& userAgent.toLowerCase().includes('prerender');
	}
}
